import styled from "../../styled-components.mjs";
export var LabelInner = styled.span.withConfig({
  displayName: "LabelInner",
  componentId: "sc-19pye2k-0"
})(["display:inline-block;"]);